import { css } from "@emotion/react"
import {
    AppBar as _AppBar,
    Box,
    Link,
    Menu,
    MenuItem,
    Toolbar,
} from "@mui/material"
import useProfile from "common/hooks/swr/useProfile"
import { useSegmentTrack } from "common/hooks/useSegmentTrack"
import Image from "components/image/Image"
import ImpersonateInput from "features/UnitTracker/components/ImpersonateInput"
import * as idp from "lib/idp"
import { useRouter } from "next/router"
import { useState } from "react"
import { Midnight } from "themes/colours"
import Icon from "../icon/icon"
import * as styles from "./AppBar.styles"

type Props = {
    children?: JSX.Element
}

function displayImpersonationInput(pathname: string): boolean {
    return pathname === "/"
}

/**
 * AppBar component showing Menu icon, Vacasa logo, and user account.
 */
const AppBar = ({ children }: Props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const { data: profile } = useProfile()
    const { trackNavigation } = useSegmentTrack()
    const { pathname } = useRouter()

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        trackNavigation("/logout").finally(() => {
            idp.removeToken()
            window.location.href = idp.getLogoutLink()
        })
    }

    return (
        <_AppBar css={styles.MuiAppBar}>
            <Toolbar css={styles.MuiToolbar}>
                <Link href="/" underline="none">
                    <Image
                        src={"vacasa-logo.svg"}
                        height={28}
                        width={120}
                        layout="fixed"
                        alt="logo"
                    />
                </Link>
                {idp.isAuthorized() && (
                    <Box css={styles.MuiToolbarRight}>
                        {displayImpersonationInput(pathname) ? (
                            <ImpersonateInput />
                        ) : (
                            <></>
                        )}

                        <Link href="" onClick={handleMenu} underline="none">
                            Hi, {profile?.firstName}
                            <Icon
                                css={css`
                                    margin-left: 20px;
                                `}
                                name="arrow-dropdown"
                                size={10}
                                color={Midnight[80]}
                            />
                        </Link>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>
                    </Box>
                )}
            </Toolbar>
        </_AppBar>
    )
}

export default AppBar
